import { FormikHelpers } from "formik";
import { useCreateOteFpa } from "./api/createOteFpa";
import OteFpaForm from "./OteFpaForm";


const CreateOteFpa = ({handleCloseModal}: CreateOteFpaProps)  => {
  const createOteFpaMutation = useCreateOteFpa({data: {}});

  const initialValues: IPostNewOteFpa = {
    description: "",
    deleted: false
  };

  const handleSubmit = async (values: IPostNewOteFpa, { setSubmitting }: FormikHelpers<IPostNewOteFpa>): Promise<void> => {
    try {
      await createOteFpaMutation.mutateAsync({
        data: values,
      });
      handleCloseModal();
    } catch (error) {
      console.log(error);
      console.log("values", values);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <OteFpaForm initialValues={initialValues} type="create" onSubmit={handleSubmit} />
  )
}

interface CreateOteFpaProps {
  handleCloseModal: () => void;
}

export default CreateOteFpa;